/**
 * Bump a document version string.
 * Whole numbers stay whole numbers ("22" becomes "23").
 * Dotted versions bump the minor part and keep any suffix ("1.4-rc" becomes "1.5-rc").
 * Anything else falls back to "1.1".
 */
export function bumpDocVersion(v: string): string {
  const s = String(v ?? "").trim();
  if (/^\d+$/.test(s)) return String(Number(s) + 1);
  const m = s.match(/^(\d+)\.(\d+)(.*)$/);
  if (m) return `${m[1]}.${Number(m[2]) + 1}${m[3] || ""}`;
  return "1.1";
}
